module.exports = __webpack_public_path__ + "img/2x.cea5549.jpg";